import React, { Component } from 'react';
import moment from 'moment';

import InfoBand from './infoBand';
import PhotoPreview from './photoPreview';
import Modal from '../../components/common/modal'

import { UPLOAD_PHOTO_WIZARD_STATE} from "../../containers/busServiceInfo/constants";

import UploadSuccess from '../../images/upload-success.svg'
import './styles.css'

const formatTime = (date) => date? moment(date).format('hh:mm A') : '';

export default class BusServiceInfo extends Component{
  constructor(props){
    super(props);
    this.state = {
      activeTabId: '',
      renderSelectedBusPhotos: [],
      uploadSelectedPhotos: [],
      selectedTags: {},
      fileUrls: {},
      isSuccessModalOpen: false,
    }
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if(Object.keys(nextProps.successData).length && !prevState.isSuccessModalOpen) {
      return { isSuccessModalOpen: true };
    }
    return { isSuccessModalOpen: false };
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.props.metaDetails !== prevProps.metaDetails && !this.state.activeTabId) {
      this.setState({ activeTabId: Object.keys(this.props.metaDetails.categories || {})[0] });
    }
  }

  onTabChange = (e) => {
    this.setState({ activeTabId: e.target.id });
  }

  renderBusCategory = () => {
    let { activeTabId } = this.state;
    let busCategories = this.props.busCategoriesList.map((busCategory, i) => {
      return (
        <li key={i} className='busCategoryItems' onClick={() => this.onBusCategoryClick(busCategory)}>
          {busCategory}
        </li>
      )
    });

    return(
      <div className='busServiceInfo'>
        <h1 className='heading'>Bus Photos</h1>
        {/*<h1 className="busImagesHeading">Bus Images</h1>*/}
        <div className='flex capitalize tabWrp'>
          {
            Object.entries(this.props.metaDetails.categories || {}).map(([id, name], index) => (
              <div
                key={id}
                id={id}
                onClick={this.onTabChange}
                className={`catTab cursor ${activeTabId === id? 'activeCatTab': ''}`}
              >
                {name}
              </div>
            ))
          }
        </div>

        <div>
          <input type='radio' name='Upload New Photos' checked readOnly className='catNewPhotoUpload' />
          <span className='uploadNewPhotosHeading'>Upload New Photos</span>
        </div>
        <div>
          <h1 className='catBusType'>Bus Type</h1>
          <ul className='catWrp'>{busCategories}</ul>
        </div>
      </div>
    )
  }

  onBusCategoryClick = (busCategory) => {
    // Set State of upload widget and current Selected Category
    this.props.fetchBusServices(busCategory);
  }

  renderBusCategoryServices = () => {
    const {
      selectedBusServices,
      selectedBusCategory,
      busServicesForCategories,
      // isSelectedService,
      isSelectAllServices
    } = this.props;

    let selectedServicesCount = Object.keys(selectedBusServices).length;
    let busServicesInfo = busServicesForCategories[selectedBusCategory];
    // let paytmRouteIds = busServicesInfo.map((busService) => busService.meta.bus_type_name)

    let busRoutes = busServicesInfo.map((busRoute, i) => {
      return (
        <li key={i} className='busRouteItems'>
          <input
            id='busRoute'
            type='checkbox'
            className='busServices'
            data-route={busRoute.route_time_id}
            checked={selectedBusServices[busRoute.route_time_id] || false}
            onChange={this.onServiceSelection} />
          <label style={{ 'paddingLeft': '10px', textTransform: 'capitalize' }}>
            {busRoute.meta.source_name} to {busRoute.meta.destination_name}  ({formatTime(busRoute.meta.departure_datetime)})
          </label>
        </li>
      )
    })

    return (
      <div className="busServiceInfo">
        <div className='headerWrp'>
          <div style={{ flex: 1 }}>
            <h1 className="heading" onClick={this.goToBusServiceInfo}>
              <span className='catBackButton'>&#8592;</span>
              {selectedBusCategory}
              <br />
              <span className='selectedSerCnt'>
                {selectedServicesCount} out of {busServicesInfo.length} Buses Selected
              </span>
            </h1>
          </div>
          <div>
            <button
              disabled={this.getButtonDisableState(selectedBusServices)}
              onClick={this.goToPhotoSelection}
              className="nextButton"
            >
              Next
            </button>
          </div>
        </div>
        <div className="servicesWrapper">
          <li className="busRouteItems">
            <input checked={isSelectAllServices} type="checkbox" id="busRoute" onChange={this.selectAllServicesHandler} />
            <label className="catAllServices">Select all services</label>
          </li>
          <ul style={{ display: 'flex', flexFlow: 'wrap' }}>
            {busRoutes}
          </ul>
        </div>
      </div>
    );
  }

  onServiceSelection = (e) => {
    let checkboxState = e.target.checked;
    let selectedRoute = e.target.dataset.route;
    this.props.selectIndividualServicesHandler(checkboxState, selectedRoute);
  }

  selectAllServicesHandler = (e) => {
    let checkboxState = e.target.checked;
    this.props.selectAllServicesHandler(checkboxState);
  }

  goToPhotoSelection = () => {
    this.props.goToPhotoSelection();
  }

  renderPhotoSelection = () => {
    const { selectedBusCategory, selectedBusServices /*uploadSelectedPhotos*/ } = this.props;
    return (
      <div className="busServiceInfo">
        <div className='headerWrp'>

          <div style={{ flex: 1 }}>
            <h1 className="heading noBorder" onClick={() => this.busCategoryClickHandler(selectedBusCategory)}>
              <span className='catBackButton'>&#8592;</span>
              Upload Photos ({Object.keys(selectedBusServices).length} buses)
              <br />
              <span className='selectedSerCnt'>
                {selectedBusCategory}
              </span>
            </h1>
          </div>

          <div>
            <button
              disabled = {!(this.state.renderSelectedBusPhotos.length > 0)}
              className="nextButton"
              onClick={this.uploadSelectedPhotosHandler}
            >
              Upload
            </button>
          </div>
        </div>

        <InfoBand />

        <div className='photoWrp'>
          <div className="addPhotosWrapper photoGap">
            <div className="addPhotosBtnbLbl">
              <button className="addPhotosButton color00b9f5">&#8853;</button>
              <div className="color00b9f5">Add Photos</div>
            </div>
            <input
              type="file"
              id="input"
              multiple
              accept="image/*"
              onChange={this.onPhotoSelection}
            />
          </div>
          {this.state.renderSelectedBusPhotos && this.state.renderSelectedBusPhotos.length > 0?
            <PhotoPreview
              metaDetails={this.props.metaDetails}
              fileUrls={this.state.fileUrls}
              onTagSelection={this.onTagSelection}
              deletePhoto={this.deletePhoto}
            />
          : null }
        </div>
      </div>
    )
  }

  deletePhoto = (nameHashCode) => {
    let fileUrls = Object.assign(this.state.fileUrls);
    delete fileUrls[nameHashCode];
    this.setState(prevState => ({
      renderSelectedBusPhotos: prevState.renderSelectedBusPhotos.filter((el, i) => nameHashCode != this.hashCode(el.name)),
      fileUrls
    }))
  }

  busCategoryClickHandler = (busCategory) => {
    // Set State of upload widget and current Selected Category
    this.props.goToBusServices(busCategory)
  }

  getButtonDisableState = (selectedBusServices) => {
    return !(Object.values(selectedBusServices).filter( value => value === true).length > 0)
  }

  goToBusServiceInfo = () => {
    // Reset State and take to first level of upload widget
    this.props.goToBusCategories()
  }

  onPhotoSelection = (e) => {
    let originalFiles = e.target.files;
    let files = [...originalFiles];
    let tempArr = [];
    if(this.state.renderSelectedBusPhotos.length + files.length > 10){
      alert(`You can upload max. 10 photos`);
      let numberOfFilesToDrop = this.state.renderSelectedBusPhotos.length + files.length - 10;
      files.splice(files.length - numberOfFilesToDrop)
    }
    for(let i = 0; i < files.length; i++){
      let fileSize = files[i].size / (1024.0 * 1024.0)
     if(fileSize <= 5.0) {
        tempArr.push(files[i]);
      } else {
        alert(`${files[i].name} is greater than 5 MB, this image will not be uploaded!`)
      }
    }
    this.setState({
      renderSelectedBusPhotos: [...this.state.renderSelectedBusPhotos, ...tempArr]
    }, () => {
      this.generateUrlAndUpdateState(tempArr);
    })
  }

  generateUrlAndUpdateState = (files) => {
    files.forEach(file => this.getFileUrlAndUpdateState(file))
  }

  getFileUrlAndUpdateState = (file) => {
    // 1. Initialize File Reader
    const reader = new FileReader();

    // 2. Attach onLoad Listener which updates the state of the component with the generated URL.
    reader.onloadend = this.setImageUrlInStateForFile(file);

    // 3. Async Call to create URL.
    reader.readAsDataURL(file);
  }

  setImageUrlInStateForFile = (file) => {
    let nameHashCode = this.hashCode(file.name);
    return (e) => {
      let fileData = e.target.result;
      this.setState(prevState => ({
        fileUrls: {
          ...prevState.fileUrls,
          [nameHashCode]:  { data: fileData, loaded: true, tagsArray: [] }
        }
      }))
    }
  }

  hashCode = (s) => {
    let h = 0, l = s.length, i = 0;
    if (l > 0)
      while (i < l)
        h = (h << 5) - h + s.charCodeAt(i++) | 0;
    return h;
  }

  onTagSelection = (tagKey, nameHashCode) => {
    let fileData = { ...this.state.fileUrls[nameHashCode]};
    if(fileData.tagsArray.includes(+tagKey)) {
      fileData.tagsArray = fileData.tagsArray.filter(el => el !== +tagKey);
    } else {
      fileData.tagsArray.push(+tagKey);
    }
    this.setState(prevState => ({
      fileUrls: {
        ...prevState.fileUrls,
        [nameHashCode]: fileData
      }
    }))
  }

  uploadSelectedPhotosHandler = () => {
    let formDataArr = [];
    const { activeTabId, fileUrls, renderSelectedBusPhotos } = this.state;
    const { busServicesForCategories, selectedBusCategory, selectedBusServices } = this.props;

    let busServicesInfo = busServicesForCategories[selectedBusCategory];

    for(let i=0; i<renderSelectedBusPhotos.length; i++) {
      let el = renderSelectedBusPhotos[i];
      let hashCode = this.hashCode(el.name);

      if(!fileUrls[hashCode].tagsArray || !fileUrls[hashCode].tagsArray.length) {
        alert('Kindly select the tags for Images: ' + el.name + ' photo.');
        return;
      }

      let formData = new FormData();
      let tripInfo = [];

      busServicesInfo.forEach(info => {
        if(selectedBusServices[info.route_time_id]) {
          tripInfo.push({
            provider_id: info.provider_id,
            operator_id: info.operator_id,
            route_time_id: info.route_time_id,
            paytm_trip_id: info.paytm_trip_id
          })
        }
      })

      formData.append('image', el);
      formData.append('trip_info', JSON.stringify(tripInfo));
      formData.append('photo_info', JSON.stringify({ category_id: activeTabId, tags: JSON.stringify(fileUrls[hashCode].tagsArray) }));

      formDataArr.push(formData);
    }

    this.props.uploadSelectedPhotosHandler(formDataArr, () => {
      
    });
  }

  onCloseClick = () => {
    this.setState({
      isSuccessModalOpen: false,
      // activeTabId: '',
      renderSelectedBusPhotos: [],
      uploadSelectedPhotos: [],
      selectedTags: {},
      fileUrls: {},
    })
    this.props.resetStore();
  }

  render() {
    const { uploadNewPhotosWizardState, successData } = this.props;
    let uiElements = null;
    switch(uploadNewPhotosWizardState) {
      case UPLOAD_PHOTO_WIZARD_STATE.CATEGORY_SELECTION:
        uiElements = this.renderBusCategory();
        break;
      case UPLOAD_PHOTO_WIZARD_STATE.ROUTES_SELECTION:
        uiElements = this.renderBusCategoryServices();
        break;
      case UPLOAD_PHOTO_WIZARD_STATE.PHOTOS_SELECTION:
        uiElements = this.renderPhotoSelection();
        break;
      default:
        uiElements = this.renderBusCategory();
    }
    return(
      <div>
        {this.state.isSuccessModalOpen &&
          <Modal classes="transparent" overlay>
            <div>
              <a href="javascript:void(0)" title="Close" className="closeLoginModal" onClick={this.onCloseClick}>X</a>
              <div className="backgroundPopup">
                <div className="support-text">
                  <img style={{ marginBottom: 30 }} src={UploadSuccess} alt='Upload Success' />
                  <p>Successfully Uploaded {successData.successCount} images!</p>
                  {successData.failCount > 0?<p>Failed to upload {successData.failCount}</p>:null}
                </div>
              </div>
            </div>
          </Modal>
        }
        {uiElements}
      </div>
    )
  }
}